import { combineReducers } from 'redux';
import general from './general';
import mock from './mock';

export default combineReducers({
  general,
  mock,
});
